<template>
  <div class="mt-3">
    <StoreOnboardingProgressBar
      :steps="steps"
      :current-step-index="currentStepIndex"
      :max-reachable-step-index="maxReachableStepIndex"
      @go-to-step="goToStep"
    />

    <component
      :is="currentStepComponent"
      :store="store"
      @step-completed="handleStepCompleted"
      @previous="handlePrevious"
      @activate-store="handleActivateStore"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import StoreOnboardingProgressBar from "./StoreOnboardingProgressBar.vue";
import StoreOnboardingStepGeneralInfo from "./StoreOnboardingStepGeneralInfo.vue";
import StoreOnboardingStepContacts from "./StoreOnboardingStepContacts.vue";
import StoreOnboardingStepAfterSales from "./StoreOnboardingStepAfterSales.vue";
import StoreOnboardingStepBilling from "./StoreOnboardingStepBilling.vue";
import StoreOnboardingStepVerticals from "./StoreOnboardingStepVerticals.vue";
import StoreOnboardingStepConfiguration from "./StoreOnboardingStepConfiguration.vue";

const STEPS = [
  { key: "generalInfo", label: "Informations", component: "StoreOnboardingStepGeneralInfo" },
  { key: "contacts", label: "Coordonnées", component: "StoreOnboardingStepContacts" },
  { key: "afterSales", label: "SAV", component: "StoreOnboardingStepAfterSales" },
  { key: "billing", label: "Facturation", component: "StoreOnboardingStepBilling" },
  { key: "verticals", label: "Offres", component: "StoreOnboardingStepVerticals" },
  { key: "configuration", label: "Configuration", component: "StoreOnboardingStepConfiguration" },
];

export default {
  name: "StoreOnboarding",
  components: {
    StoreOnboardingProgressBar,
    StoreOnboardingStepGeneralInfo,
    StoreOnboardingStepContacts,
    StoreOnboardingStepAfterSales,
    StoreOnboardingStepBilling,
    StoreOnboardingStepVerticals,
    StoreOnboardingStepConfiguration,
  },
  props: { store: { type: Object, required: true } },
  emits: ["store-updated", "store-activated"],
  data() {
    return {
      currentStepIndex: 0,
      maxReachableStepIndex: 0,
    };
  },
  computed: {
    steps() {
      return STEPS;
    },
    currentStepComponent() {
      return STEPS[this.currentStepIndex].component;
    },
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("stores", ["updateStatus"]),

    handleStepCompleted() {
      this.$emit("store-updated");
      if (this.currentStepIndex < STEPS.length - 1) {
        this.currentStepIndex++;
        if (this.currentStepIndex > this.maxReachableStepIndex) {
          this.maxReachableStepIndex = this.currentStepIndex;
        }
      }
    },

    handlePrevious() {
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
      }
    },

    goToStep(index) {
      this.currentStepIndex = index;
    },

    async handleActivateStore() {
      this.$emit("store-updated");
      const { success } = await this.updateStatus({
        storeId: this.store.id,
        status: "active",
      });
      if (!success) return;

      await this.notify({
        category: "simple",
        type: "success",
        title: "Le point de vente a été activé",
      });
      this.$emit("store-activated");
    },
  },
};
</script>
